export default __webpack_public_path__ + "static/media/Hemkunskap5.0e61457d.jpeg";